// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__1UIy4","title":"BackImages_title__1lGXY","images":"BackImages_images__1CY7T"};